import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import store from './store'
import { enqueueErrorSnackbar } from './redux/actions/notificationActions'

/** Shared by the sign-in page and the logged-in app, so branding can be queried before login. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 0,
      retry: 0,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.silent) return
      store.dispatch(enqueueErrorSnackbar({ error, operation: query.meta?.operation }))
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _v, _, mutation) => {
      store.dispatch(enqueueErrorSnackbar({ error, operation: mutation.meta?.operation }))
    },
  }),
})
